import Grid from "@mui/material/Grid";
import ImagesGallery from "../../../components/imagesGallery/ImagesGallery";
import Typography from "@mui/material/Typography";
import type { Product } from "../../../components/productDetails/ProductDetails";
import type { PropsWithChildren } from "react";

export function MapProductDetails({
  product,
  children,
}: PropsWithChildren<{
  readonly product: Product;
}>) {
  const hasImages: boolean = product.images.length > 0;
  return (
    <Grid container spacing={2}>
      <Grid size={hasImages ? 6 : 12} spacing={2} container sx={{ flexDirection: "column" }}>
        {/*vertical align top*/}
        <Grid size={12}>
          <Typography>{product.description?.polish ?? "n.d."}</Typography>
        </Grid>
        <Grid size={12}>
          <Typography variant="caption">Adres</Typography>
          <Typography>{product.contact?.address ?? "n.d."}</Typography>
        </Grid>
      </Grid>
      {hasImages && (
        <Grid
          size={6}
          spacing={2}
          container
          sx={{
            height: 200,
          }}
        >
          <Grid size={12}>
            <ImagesGallery
              images={product.images.map((i) => ({ name: i.name, url: i.thumbnail.url }))}
              maxWidth={250}
            />
          </Grid>
        </Grid>
      )}
      {children}
    </Grid>
  );
}
